import React from 'react';
import { Skeleton } from 'antd';
import { currencyFormatter } from '../../../../../shared/components/ui/atoms';
import { InfoTooltip } from './Tooltip';
import { AdjustLoanAmount } from './AdjustLoanAmount';
import { AdjustLTVAmount } from './AdjustLTVAmount';

interface LoanDetailsProps {
  min_ltv?: number;
  max_ltv?: number;
  ltv: number;
  arv_ltv?: number;
  ltc?: number;
  isLoading: boolean;
  loanBalance: number;
  setLoanBalance: (value: number) => void;
  setLtv: (value: number) => void;
}

export const LoanDetails = (props: LoanDetailsProps) => {
  const { min_ltv, max_ltv, ltv, arv_ltv, ltc, isLoading, loanBalance, setLoanBalance, setLtv } = props;

  const loanAmountAdjuster = React.useMemo(
    () => <AdjustLoanAmount loanBalance={loanBalance} setLoanBalance={setLoanBalance} />,
    [loanBalance, setLoanBalance]
  )

  const ltvAdjuster = React.useMemo(
    () => <AdjustLTVAmount ltv={ltv} min_ltv={min_ltv} max_ltv={max_ltv || 0} setLtv={setLtv} />,
    [min_ltv, max_ltv, ltv, setLtv]
  )

  return (
    <div className='loan-details-onboarding'>
      <div>
        <span>
          Total loan amount
        </span>
        <span>
          {
            isLoading ?
              <Skeleton.Input />
              :
              <React.Fragment>
                <span>{`$${currencyFormatter(loanBalance).split(".")[0]}`}</span>
                {loanAmountAdjuster}
              </React.Fragment>
          }
        </span>
        
      </div>
      {
        isLoading ?
        null
        :
        arv_ltv ?
          <div>
            <div className='arv'>
              <div>
                <span>
                  ARV LTV{" "}
                  <InfoTooltip title={"To adjust ARV LTV, change desired as-is LTV on the left"} placement={"top"} variant="gray" isDisabled={false} />
                </span>
                <span>
                  {
                    isLoading ?
                      <Skeleton.Input />
                      :
                      `${(arv_ltv * 100).toFixed(0)}%`
                  }
                </span>
              </div>
              <div>
                <span>
                  LTC{" "}
                  <InfoTooltip title={"To adjust LTC, change desired as-is LTV on the left"} placement={"top"} variant="gray" isDisabled={false} />
                </span>
                <span>
                  {
                    isLoading ?
                      <Skeleton.Input />
                      :
                      `${(ltc && !isNaN(ltc) ? ltc * 100 : 0).toFixed(1)}%`
                  }
                </span>
              </div>
            </div>
            <div className='loan-details-caption'>
              Use left slider to adjust as-is LTV
            </div>
          </div>
          :
          <div>
            <span className='ltv-label'>
              LTV{" "}
              <InfoTooltip title={"To adjust LTV, change the numbers on the left or use the slider"} placement={"top"} variant="gray" isDisabled={false} />
            </span>
            <span>
              {
                isLoading ?
                  <Skeleton.Input />
                  :
                  <React.Fragment>
                    <span>{Number.isInteger(ltv * 100) ? (ltv * 100) : (ltv * 100).toFixed(1)}%</span>
                    {ltvAdjuster}
                  </React.Fragment>
              }
            </span>
          </div>
      }
    </div>
  )
}

